import {SierraCanvas} from '../../classes/sierraCanvas';

/**
 * @name browserSupportsWebP
 * @description Checks if the current web browser supports the experimental image
 * format .webp
 * If available, .webp will be used as the default file format over .png
 * in some situations.
 */
export const browserSupportsWebP = (): boolean => {
  return SierraCanvas.browserSupportsWebP();
};
